import { graphql } from '../../graphql/generated';

export const DOCTORS_FOR_CURRENT_USER_QUERY = graphql(`
  query DoctorsForCurrentUser {
    doctorsForCurrentUser {
      id
      name
      meAddress
      firstName
      lastName
      postTitle
      preTitle
      salutation
      disabled
    }
  }
`);
